(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
     
  const url = new URL(window.location.href); 
  if (url.hash) { 
    document.addEventListener( 
      'DOMContentLoaded', 
      () => { 
        const card = document.getElementById(url.hash.slice(1)); 
        if (card) { 
          card.scrollIntoView({ behavior: 'instant' }); 
        } 
      }, 
      { once: true } 
    ); 
  } 
 
  // description script // 
  document.addEventListener('DOMContentLoaded', () => { 
    document.querySelectorAll('.collection-description-content').forEach((content) => { 
 
      const updateCollapsedHeight = () => { 
        const paragraph = content.querySelector('p'); 
 
        if (!paragraph) return; 
 
        const paragraphStyle = window.getComputedStyle(paragraph); 
 
        let lineHeight = parseFloat(paragraphStyle.lineHeight); 
 
        if (isNaN(lineHeight)) { 
          lineHeight = parseFloat(paragraphStyle.fontSize) * 1.5; 
        } 
 
        /* 
          Get the exact position of the paragraph 
          relative to the content container 
        */ 
        const contentRect = content.getBoundingClientRect(); 
        const paragraphRect = paragraph.getBoundingClientRect(); 
 
        const paragraphTop = 
          paragraphRect.top - contentRect.top; 
 
        /* Heading + exactly 2 paragraph lines */ 
        const collapsedHeight = 
          paragraphTop + (lineHeight * 2); 
 
        content.dataset.collapsedHeight = collapsedHeight; 
 
        /* Only apply collapsed height if not expanded */ 
        if (!content.classList.contains('is-expanded')) { 
          content.style.height = collapsedHeight + 'px'; 
        } 
      }; 
 
      /* Calculate initially */ 
      updateCollapsedHeight(); 
 
      /* Recalculate on every screen size */ 
      window.addEventListener('resize', () => { 
        if (!content.classList.contains('is-expanded')) { 
          updateCollapsedHeight(); 
        } 
      }); 
 
    }); 
  }); 
 
 
  document.addEventListener('click', (event) => { 
    const button = event.target.closest('.collection-read-more'); 
 
    if (!button) return; 
 
    const content = document.getElementById(button.dataset.target); 
 
    if (!content) return; 
 
    const collapsedHeight = parseFloat( 
      content.dataset.collapsedHeight 
    ); 
 
    const buttonText = button.querySelector('.collection-read-more__text'); 
 
    if (content.classList.contains('is-expanded')) { 
 
      /* Get current full height */ 
      content.style.height = content.scrollHeight + 'px'; 
 
      requestAnimationFrame(() => { 
        content.classList.remove('is-expanded'); 
        content.style.height = collapsedHeight + 'px'; 
      }); 
 
      if (buttonText) { 
        buttonText.textContent = 'Read More'; 
      } 
 
      button.setAttribute('aria-expanded', 'false'); 
 
    } else { 
 
      /* Start from collapsed height */ 
      content.style.height = collapsedHeight + 'px'; 
 
      requestAnimationFrame(() => { 
        const fullHeight = content.scrollHeight; 
 
        content.classList.add('is-expanded'); 
 
        content.style.height = fullHeight + 'px'; 
      }); 
 
      if (buttonText) { 
        buttonText.textContent = 'Read Less'; 
      } 
 
      button.setAttribute('aria-expanded', 'true'); 
 
      content.addEventListener( 
        'transitionend', 
        () => { 
          if (content.classList.contains('is-expanded')) { 
            content.style.height = 'auto'; 
          } 
        }, 
        { once: true } 
      ); 
    } 
  }); 
  // description script end // 

  } catch(e) { console.error(e); }
})();
})();
